import {
  ApiEnveloppe,
  CreateGraphResponse,
  GetAllGraphsResponse,
  GetAutoGraphDataXTResponse,
  GetGraphDataResponse,
  GetGraphResponse,
  UpdateGraphResponse,
} from '../../types/types';
import { _post, _postSafe, requestType } from './_internal';

export const getAllGraphs = (payload: {
  projects_id: any;
}): Promise<GetAllGraphsResponse> => {
  return _post({
    request_type: requestType.recuperation_de_la_liste_des_graphes,
    projects_id: payload.projects_id,
  });
};

export const deleteGraph = (payload: {
  graph_id: string;
}): Promise<ApiEnveloppe> => {
  return _post({
    request_type: requestType.supprimer_un_graphe,
    graph_id: payload.graph_id,
  });
};

export const getGraph = (payload: {
  graph_id: string;
}): Promise<GetGraphResponse> => {
  return _postSafe({
    request_type: requestType.recuperer_un_graphe,
    graph_id: payload.graph_id,
  });
};

export const getGraphData = (payload: {
  graph_id: string;
  time_period?: any;
  measures_num?: any;
  select_time?: any;
  time_interval?: any[];
}): Promise<GetGraphDataResponse> => {
  const { graph_id, time_period, measures_num, select_time, time_interval } =
    payload;
  return _postSafe({
    request_type: requestType.recuperation_des_donnees_d_un_graphe,
    graph_id,
    time_period: time_period === undefined ? null : time_period,
    measures_num: measures_num === undefined ? null : measures_num,
    select_time: select_time === undefined ? [] : select_time,
    time_interval: time_interval === undefined ? [null, null] : time_interval,
  });
};

export const getAutoGraphDataXT = (payload: {
  sensor_id: string;
  position_in_sensor: number;
  time_period?: any;
  measures_num?: any;
  select_time?: any;
  time_interval?: any[];
}): Promise<GetAutoGraphDataXTResponse> => {
  const {
    sensor_id,
    position_in_sensor,
    time_period,
    measures_num,
    select_time,
    time_interval,
  } = payload;
  return _postSafe({
    request_type:
      requestType.recuperation_des_donnees_d_un_graphe_automatique_xt,
    sensor_id,
    position_in_sensor,
    time_period: time_period === undefined ? null : time_period,
    measures_num: measures_num === undefined ? null : measures_num,
    select_time: select_time === undefined ? [] : select_time,
    time_interval: time_interval === undefined ? [null, null] : time_interval,
  });
};

export const createGraph = (payload: {
  config: any;
}): Promise<CreateGraphResponse> => {
  return _post({
    request_type: requestType.creer_un_graphe,
    config: payload.config,
  });
};

export const updateGraph = (payload: {
  config: any;
}): Promise<UpdateGraphResponse> => {
  return _post({
    request_type: requestType.modifier_un_graphe,
    config: payload.config,
  });
};
